import { Badge } from '~/components/UI/Badge'
import i18n from '~/i18n'

const dimensionTitle = `${i18n.t('rm:adsize.form.text.width')} x ${i18n.t('rm:adsize.form.text.height')}`

const SizeBadges: React.FC<{ data: Placement }> = ({ data }) => (
  <div className="placements-formats d-flex">
    {data.formats
      .filter(item => !!item?.size)
      .map(item => (
        <div className="placements-formats-name" key={item.id}>
          <Badge template="primary">
            {item.size}{' '}
            <Badge size="tiny" className="ms-1 me-0" title={dimensionTitle}>
              {item.width} x {item.height}
            </Badge>
          </Badge>
        </div>
      ))}
  </div>
)

export default SizeBadges
